export default {
  options: {
    units: {
      kilometers: 'Kilometer',
      meters: 'Meter',
      miles: 'Meilen'
    },
    areUnits: {
      sqKms: 'km²',
      hectare: 'Hektar',
      sqMeters: 'm²'
    }
  }
}
